import { h } from "../kit/dom.ts";

export interface ArrowTarget {
  id: string;
  kind: "aliado" | "chefe";
  /** Número do slot (aliado) ou a coroa (chefe). */
  label: string;
  color: string;
  x: number;
  y: number;
  angle: number;
}

/** Setas na borda da tela (F63): uma por alvo fora dela, reaproveitadas por id. */
export class OffscreenArrows {
  readonly element: HTMLElement;
  private readonly arrows = new Map<string, HTMLElement>();

  constructor(parent: HTMLElement) {
    this.element = h("div", { id: "setas", "aria-hidden": "true" });
    parent.appendChild(this.element);
  }

  update(targets: readonly ArrowTarget[]): void {
    const seen = new Set<string>();
    for (const t of targets) {
      seen.add(t.id);
      let el = this.arrows.get(t.id);
      if (!el) {
        el = h("div", { class: `seta ${t.kind}` }, h("span", { class: "ponta" }), h("span", { class: "rotulo" }));
        this.arrows.set(t.id, el);
        this.element.appendChild(el);
      }
      el.hidden = false;
      el.style.setProperty("--cor", t.color);
      el.style.transform = `translate(${t.x.toFixed(0)}px, ${t.y.toFixed(0)}px)`;
      (el.firstChild as HTMLElement).style.transform = `rotate(${t.angle.toFixed(3)}rad)`;
      (el.lastChild as HTMLElement).textContent = t.label;
    }
    for (const [id, el] of this.arrows) if (!seen.has(id)) el.hidden = true;
  }
}
